export default "__VITE_ASSET__c2a9f22e__"